<script setup>
import ChatMessage from './ChatMessage.vue';
import ChatRecentConversations from './ChatRecentConversations.vue';
import ChatTypingIndicator from './ChatTypingIndicator.vue';
import { useTemplateRef } from 'vue';

const props = defineProps({
	messages: {
		type: Array,
		default: () => []
	},
	loading: Boolean,
	bottomSentinel: {
		type: Object,
		default: null
	}
});

const emit = defineEmits(['scroll', 'send-preset']);

const messageContainer = useTemplateRef('messageContainer');
const messagesContent = useTemplateRef('messagesContent');

defineExpose({
	messageContainer,
	messagesContent
});


function onScroll (event) {
	emit('scroll', event);
}
</script>

<template>
  <div
    ref="messageContainer"
    class="messages-container"
    :class="{ 'is-empty': messages.length === 0 }"
    @scroll="onScroll"
  >
    <div
      ref="messagesContent"
      class="messages-content"
    >
      <ChatRecentConversations />

      <ChatMessage
        v-for="(m, i) in messages"
        :key="i"
        :message="m"
      />

      <ChatTypingIndicator v-if="loading" />
    </div>
  </div>
</template>


<style scoped lang="scss">
.messages-container {
  position: relative;
  flex: 1;
  overflow-y: auto;
  background: $white;
  padding: 12px;

  &.is-empty {
    overflow: hidden;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: $color-grey-300;
    border-radius: 4px;

    &:hover {
      background: $color-grey-400;
    }
  }
}

.messages-content {
  min-height: 100%;
}

.is-empty .messages-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>
